import { Layout } from 'antd';

import { environment } from '../../environment/environment';

const year = new Date().getFullYear();

const FooterComponent = () => {
  return (
    <Layout.Footer style={{ padding: '12px' }}>
      <span>
        Copyright © {year} TryCycle Data Systems Inc. All rights reserved. Version: {environment.versionNumber}.
        {environment.buildNumber}
      </span>
    </Layout.Footer>
  );
};

export default FooterComponent;
